import React from 'react'
import { useFocusEffect } from 'expo-router'

/**
 * Reopen a modal when its screen regains focus after navigating away from it.
 *
 * Native modals and expo-router pushes don't stack, so a screen closes its
 * modal (e.g. the map picker) before pushing another route (map details).
 * Call the returned `markForReopen()` just before that push; when the user
 * comes back, `setOpen(true)` runs once and the modal is where they left it.
 */
export function useReopenOnFocus(setOpen: (open: boolean) => void): () => void {
  const pending = React.useRef(false)
  useFocusEffect(
    React.useCallback(() => {
      if (!pending.current) return
      pending.current = false
      setOpen(true)
    }, [setOpen]),
  )
  return React.useCallback(() => { pending.current = true }, [])
}
